import { render, staticRenderFns } from "./maintain.vue?vue&type=template&id=70597bab&scoped=true&"
import script from "./maintain.vue?vue&type=script&lang=js&"
export * from "./maintain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70597bab",
  null
  
)

export default component.exports